/**
 * Create System Setting context for custom hook
 */


import { createContext } from 'react'

const TenantsContext = createContext({
  tenants: [],
  tenantsReady: false,
})

export default TenantsContext
